import { jsx as _jsx } from "react/jsx-runtime";
export const ForwardArrow = (props) => {
    const { width = "20px" } = props;
    return (_jsx("svg", Object.assign({ viewBox: "0 0 48 48", width: width, xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "m18.75 37.2-3.35-3.35 9.9-9.9-9.9-9.9 3.35-3.35L32 23.95Z", fill: "currentColor" }) })));
};
